import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  border-radius: 8px;
  background: ${COLOR_WHITE};
  padding: 16px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SectionAction = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 28px;
`;

const ContainerField = styled.div`
  width: 100%;
`;

const FIELD_LIST = ["name", "width", "height", "position_x", "position_y"];
const NUMERIC_FIELDS = ["width", "height", "position_x", "position_y"];

export const BlockItem = ({
  index,
  item,
  onHandleUpdateBlockInputValue = () => undefined,
  onHandleOpenModal = () => undefined,
  onHandleDeleteBlock = () => undefined,
}) => {
  const onHandleChangeValue = ({ target }) => {
    const { name, value } = target;
    onHandleUpdateBlockInputValue({ index, name, value });
  };

  const onKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Container>
      {_.map(FIELD_LIST, (fieldItem) => (
        <ContainerField key={fieldItem}>
          <Text
            color={COLOR_DARK}
            fontWeight="500"
            fontSize="14px"
            style={{ marginBottom: 4, marginLeft: 4 }}
          >
            {_.startCase(fieldItem)}
          </Text>
          <StyledInput
            name={fieldItem}
            size="large"
            defaultValue={_.get(item, [fieldItem])}
            onKeyPress={(e) => {
              if (_.includes(NUMERIC_FIELDS, fieldItem)) {
                onKeyPress(e);
              }
            }}
            onChange={({ target }) => onHandleChangeValue({ target })}
          />
        </ContainerField>
      ))}
      <SectionAction>
        <Icon
          isCursor
          width={35}
          height={35}
          onClick={() => onHandleOpenModal({ item })}
        >
          <ICON_TABLE_EDIT />
        </Icon>
        <Icon
          isCursor
          width={35}
          height={35}
          onClick={() => onHandleDeleteBlock(index)}
        >
          <ICON_TABLE_DELETE />
        </Icon>
      </SectionAction>
    </Container>
  );
};
